import PartnerWidget from '@/modules/PartnerWidget/PartnerWidget.vue'

// global css variables for partner widget
import '@/modules/PartnerWidget/assets/styles/variables.css'
import { createApp, setup } from '@/setup'
// parse querystring
const search = window.location.search
  .substr(1)
  .split('&')
  .reduce((acc, pair) => {
    const tab = pair.split('=')
    acc[tab[0]] = tab[1]
    return acc
  }, {})

// import Router from '@/modules/Configurator/Router'

const element = document.getElementById('partnerWidget')

const props = { ...element.dataset, ...search }

const app = setup(createApp(PartnerWidget, props))
// app.use(Router)
app.mount(element)
